import React from 'react'
import { ThemeProvider } from '@material-ui/core/styles'

import CssBaseline from '@material-ui/core/CssBaseline'
import PropTypes from 'prop-types'
import { Head } from '@inertiajs/react'
import { PageProvider } from './Page.context'
import { usePage } from './Page.hooks'

const Page = props => {
	const [{ theme, children, metaData, fontList }] = usePage(props)

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<PageProvider value={metaData}>{children}</PageProvider>
			{_.map(fontList, font =>
				import.meta.env.SSR ? (
					<Head key={font.key}>
						<link
							head-key={font.key}
							href={font.url}
							rel="preload"
							as="style"
							/* eslint-disable-next-line react/no-unknown-property */
							onload="this.onload=null;this.rel='stylesheet'"
						/>
					</Head>
				) : (
					<Head key={font.key}>
						<link head-key={font.key} rel="stylesheet" href={font.url} />
					</Head>
				),
			)}
		</ThemeProvider>
	)
}

Page.propTypes = {
	// eslint-disable-next-line react/no-unused-prop-types
	children: PropTypes.node,
}

Page.defaultProps = {
	children: null,
}

export default Page
